import React from "react";

const AnimationSelector = ({ animations = {}, onToggle }) => {
  const types = ["confetti", "sparkles", "balloons"];

  return (
    <div className="mt-6">
      <label className="block font-semibold mb-2">Animations</label>
      <div className="space-y-2">
        {types.map((type) => (
          <div key={type} className="flex items-center gap-2">
            <input
              type="checkbox"
              id={type}
              checked={animations[type] || false}
              onChange={(e) => onToggle(type, e.target.checked)}
            />
            <label htmlFor={type} className="capitalize">
              {type}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnimationSelector;
